<template>
  <div id="return-tracking-container">
    <div class="search">
      <label class="search-label" for="search-input"
        >Pesquisar solicitações:</label
      >
      <div class="search-bar">
        <input
          type="text"
          v-model="searchedSolicitation"
          placeholder="Digite o número da solicitação..."
          id="search-input"
          @change="isSearchButtonClicked = false"
          @keyup="getInputValue($event)"
        />
        <button @click="getInputValue($event)">
          <div class="search-icon">
            <img src="@/assets/img/Magnifying_glass_icon.png" alt />
          </div>
        </button>
      </div>
    </div>
    <h1 v-show="searchedSolicitation && results.length">Resultados:</h1>
    <h1 v-show="!solicitationList.length">
      Não foram encontradas solicitações.
    </h1>
    <solicitation
      v-for="solicitation in results"
      :key="solicitation.id"
      :solicitation="solicitation"
    />
    <PreLoader />
  </div>
</template>

<script>
import store from "@/store";
import Solicitation from "@/components/home/return-tracking/Solicitation.vue";
import SolicitationsService from "@/services/return-tracking/solicitations-service.js";
import PreLoader from "@/components/home/PreLoader";
import { EventBus } from "@/eventHub";

export default {
  name: "ReturnTracking",
  components: {
    Solicitation,
    PreLoader
  },
  data() {
    return {
      solicitationList: Array,
      searchedSolicitation: "",
      isSearchButtonClicked: false
    };
  },
  methods: {
    getInputValue(key) {
      if (key.key == "Enter" || key.type == "click") {
        this.isSearchButtonClicked = true;
        this.searchedSolicitation = this.searchedSolicitation;
      } else {
        this.isSearchButtonClicked = false;
      }
    },
    sortSolicitationsByDate() {
      this.solicitationList.sort((firstDate, secondDate) => {
        let comparableFirstDate = new Date(firstDate.date);
        let comparableSecondDate = new Date(secondDate.date);
        return comparableFirstDate - comparableSecondDate;
      });
      this.solicitationList.reverse();
      EventBus.$emit("hidePreLoader");
    }
  },
  computed: {
    results() {
      if (this.isSearchButtonClicked) {
        return this.solicitationList.filter(solicitation =>
          solicitation.id.toString().startsWith(this.searchedSolicitation)
        );
      } else {
        return this.solicitationList;
      }
    }
  },
  mounted() {
    EventBus.$emit("showPreLoader");
    SolicitationsService.getAllSolicitations(store.state.customer.sapcode)
      .then(res => {
        this.solicitationList = res.data;
        this.sortSolicitationsByDate();
      })
      .catch(error => {
        console.log(error);
        EventBus.$emit("hidePreLoader");
      });
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_colors.scss";

#return-tracking-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 5%;
  position: relative;
  width: 100%;
  min-height: 400px;
  overflow: auto;

  h1 {
    color: $grey1;
  }

  @media screen and (max-height: 950px) {
    min-height: 430px;
  }
  .search {
    align-self: flex-start;
    margin-left: 23.125%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .search-label {
      display: flex;
      align-items: center;

      &:hover {
        cursor: pointer;
      }
    }

    .search-bar {
      margin: 10px 10px 10px 0;
      display: flex;
      justify-content: center;
      width: 260px;
      height: 40px;
      align-self: flex-start;
      border: 1px solid $grey3;
      align-items: center;

      input {
        height: 29px;
        margin: 0;
        padding: 3px;
        width: 100%;
        border: none;
        outline: none;

        &::placeholder {
          color: $grey3;
        }
      }

      button {
        height: 35px;
        width: 45px;
        border: none;
        outline: none;
        background-color: $white;
        div {
          transform: rotate(-40deg);
          font-size: 21px;
          font-weight: 700;
          color: $grey3;
        }
        &:hover {
          cursor: pointer;
        }
      }

      .search-solicitation {
        height: 35px;
        color: $white;
        border: none;
        background: $orange1;

        &:hover {
          cursor: pointer;
        }
      }

      .search-icon img {
        width: 20px;
        height: 20px;
        transform: rotate(30deg);
        padding-top: 5px;
        opacity: 0.6;
      }
    }
  }
}

@media (max-width: 1024px) {
  #return-tracking-container {
    width: 895px;
    overflow-x: scroll;
  }
}
</style>
